/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { ExperimentScoreCard2, parseDateRangeToQuery } from '@bingads-webui-campaign/experiment-score-card';
import { withScope } from '@bingads-webui-react/scope-service';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withGlobalFilter } from '@bingads-webui-campaign-react/global-filter-context';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { WaterfallFilterStorage, WaterfallFilterType, waterfallDateFilterProcessor } from '@bingads-webui-campaign/filter-storage';
import { StyledSubPageMenu } from '@bingads-webui-campaign-react/sub-page-menu';
import { getEntityFromScope } from '@bingads-webui/edm-campaign';
import {
  withSiteMap,
  processorSet,
} from '@bingads-webui-campaign-react/with-site-map';
import { odata } from '@bingads-webui/http-util';
import { Activity, Scenario } from '@bingads-webui-react/hoc-with-signal';

const withContexts = _.compose(withI18nConsumer, withServerContext, withPermissions, withScope);
const ExpScorecard = withContexts(ExperimentScoreCard2);
const WithSiteMapSubPageMenu = withSiteMap(
  React.memo(StyledSubPageMenu),
  processorSet.all
);

class ExperimentSubPageMenu extends React.Component {
  static defaultProps = {
    showDatePicker: true,
  };

  constructor(props) {
    super(props);

    this.waterfallFilterStorage = new WaterfallFilterStorage({
      preferenceService: this.props.preferenceService,
    });
    this.forceResetLayout = true;
  }

  componentDidMount() {
    this.props.changeLayout({ tab: { showExperimentScoreCard: true } });
  }

  componentWillUnmount() {
    this.props.changeLayout({ tab: { showExperimentScoreCard: false } });
  }

  renderScorecard() {
    const dateFilter = waterfallDateFilterProcessor(
      this.waterfallFilterStorage.getFilters([WaterfallFilterType.DateFilter]),
      this.props.serverContext
    );
    const { currentAccount } = getEntityFromScope(this.props.scope);

    if (currentAccount && this.props.experimentId) {
      const expItemFromEdm = currentAccount.Experiments.$withKey(this.props.experimentId);

      const ExpScorecardLazy = React.lazy(() =>
        odata.get(expItemFromEdm.odataURL, {
          data: parseDateRangeToQuery(dateFilter),
          oDataToken: this.props.serverContext.Token,
        }).then(experimentFromOData => ({
          default: () => <ExpScorecard experimentData={experimentFromOData} dateFilter={dateFilter} expItemFromEdm={expItemFromEdm} />,
        })).catch(() => ({
          default: () => null,
        })));

      return <ExpScorecardLazy />;
    }

    return null;
  }

  render() {
    return (
      <React.Fragment>
        {this.renderScorecard()}
        <Scenario name="sub-page-memu">
          <Activity name="experiment-sub-page-memu">
            <WithSiteMapSubPageMenu {...this.props} />
          </Activity>
        </Scenario>
      </React.Fragment>);
  }
}

export const StyledExperimentSubPageMenu = withScope(withGlobalFilter(ExperimentSubPageMenu));

ExperimentSubPageMenu.propTypes = {
  changeLayout: PropTypes.func.isRequired,
  available: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.object.isRequired,
    CurrentCustomer: PropTypes.object.isRequired,
    CurrentUser: PropTypes.object.isRequired,
    DecimalFormatter: PropTypes.object.isRequired,
    Token: PropTypes.string.isRequired,
  }).isRequired,
  showDatePicker: PropTypes.bool,
  siteMap: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  scope: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  preferenceService: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  experimentId: PropTypes.number.isRequired,
};
